import { MODEL_TYPE } from "../utils/enums";
export const depotUserModel = {
  id: undefined,
  depotId: "",
  firstName: "",
  lastName: "",
  phoneNumber: "",
  modelType: MODEL_TYPE.depotUserModel
};
